import { Component, OnInit,Input,SimpleChanges,Output,EventEmitter } from '@angular/core';
import { ArticleService } from "../../../routes/jy-content/article/service/article.service";
import {SupplierRegisterService} from '../../../routes/jy-srm/supplier/supplier-register/supplier-register.service';
import {ArticleViewService} from "@shared/components/article-view/article-view.service";
import {SettingsService} from "@delon/theme";
import {SupplierGuideService} from "../../../routes/jy-srm/supplier/supplier-guide/supplier-guide.service";
import {PersonService} from "../../../routes/jy-org/person/service/person.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-article',
  templateUrl: './article.component.html',
  styleUrls: ['./article.component.less']
})
export class ArticleComponent implements OnInit {
  @Input() articleIsVisible;
  @Input() beforLogin;
  @Input() articleId;
  @Input() noLogin:boolean;
  @Output() private closeModel = new EventEmitter();
  public articleDeail:any = {};

  constructor(private articleService:ArticleService,private supplierRegisterService:SupplierRegisterService,private articleViewService:ArticleViewService,private settingsService:SettingsService,private supplierGuideService:SupplierGuideService,private personService:PersonService,private router:Router) { }

  handleOk(){
    this.articleDeail = {};
    this.closeModel.emit();
  }
  handleCancel(){
    this.articleDeail = {};
    this.closeModel.emit();
  }
  ngOnInit() {
  }
  public isSupplieRegister:boolean = true;
  public isSupplier:boolean = false;
  public isJoin:boolean = false;
  public sourceId = null;
  public sourcingClass:string = null;
  ngOnChanges(changes: SimpleChanges){
    if(changes.articleIsVisible && this.articleIsVisible){
      if(!this.beforLogin){
        this.loading = true;
        this.articleService.get(this.articleId).subscribe((data) =>{
          this.articleDeail = data;
          this.loading = false;
        },() => this.loading = false,() => this.loading = false)
      }else{
        this.loading = true;
        this.supplierRegisterService.getNewsDetails(this.articleId).subscribe((data) =>{
          this.articleDeail = data;
          this.loading = false;
        },() => this.loading = false,() => this.loading = false)
      }
      let viewObj = {
        'fkType':'ARTICLE',
        'fkId':this.articleId
      };
      if(this.noLogin){
        this.articleViewService.addFk(viewObj).subscribe((res) => {
          if(this.articleDeail && (this.articleDeail.viewCount || this.articleDeail.viewCount === 0)){
            this.articleDeail.viewCount++;
          }
        });//每次打开文章modal框插入一条浏览记录
      }else{
        this.articleViewService.add(viewObj).subscribe((res) => {
          if(this.articleDeail && (this.articleDeail.viewCount || this.articleDeail.viewCount === 0)){
            this.articleDeail.viewCount++;
          }
        });//每次打开文章modal框插入一条浏览记录
        this.articleViewService.getSourceByArticleId(this.articleId).subscribe((res) => { //获取文章关联的寻源项目
          if(res && res.currentRound == 1 && res.currentStage && res.currentStage.status === 'GOING' && res.currentStage.type === 'ENROLL'){
            this.isJoin = true;
            this.sourceId = res.id;
            this.sourcingClass = res.sourcingClass;
          }else{
            this.isJoin = false;
            this.sourceId = null;
            this.sourcingClass = null;
          }
        });
        if(this.settingsService.user){
          if(this.settingsService.user.userType != "0"){
            this.isSupplieRegister = false;
            this.isSupplier = false;
          }else{
            this.isSupplier = true;
            this.supplierGuideService.get().subscribe((res:any) => {
              if(res.supplierDto && res.supplierDto.statusName=='注册'){
                this.isSupplieRegister = true;
              }else{
                this.isSupplieRegister = false;
              }
            })
          }
        }else{
          this.personService.getCurrent().subscribe((user) => {
            if(user.userType  != "0"){
              this.isSupplieRegister = false;
              this.isSupplier = false;
            }else{
              this.isSupplier = true;
              this.supplierGuideService.get().subscribe((res:any) => {
                if(res.supplierDto && res.supplierDto.statusName=='注册'){
                  this.isSupplieRegister = true;
                }else{
                  this.isSupplieRegister = false;
                }
              })
            }
          })
        }
      }
    }
  }

  goLogin(){
    this.router.navigateByUrl('/passport/login');
  }

  goJoin(){
    if(this.sourceId){
      this.closeModel.emit();
      setTimeout(() => {
        if(this.sourcingClass === 'INQUIRY'){
          this.router.navigateByUrl(`/parity-sup/view/${this.sourceId}/overview`);
        }else if(this.sourcingClass === 'BID'){
          this.router.navigateByUrl(`/source-sup/view/${this.sourceId}/overview`);
        }
      },300);
    }
  }

  public loading:boolean = false;

// 评论弹框
  public componentVisible:boolean = false;
  //打开评论框
  openArticleComponent(){
    this.componentVisible = true;
  }
 //关闭评论框
  closeComment(){
    this.componentVisible = false;
    if(!this.beforLogin){
      this.articleService.get(this.articleId).subscribe((data) =>{
        this.articleDeail.commentsCount = data.commentsCount;
      })
    }else{
      this.supplierRegisterService.getNewsDetails(this.articleId).subscribe((data) =>{
        this.articleDeail.commentsCount = data.commentsCount;
      })
    }
  }

//  浏览量弹框
  public viewVisible:boolean = false;
//  打开浏览量弹框
  opernArticleView(){
    this.viewVisible = true;
  }
//  关闭浏览量弹框
  closeView(){
    this.viewVisible = false;
  }

}
